import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { couponMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"
import { CouponEntity } from "../../Objects/Coupon/CouponEntity"

export const useGetCoupon = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetCoupon = async (onSuccess: any, database: string = API_ROUTES.COUPON.GET_ALL) => {
    enableLoad()

    try {
      const response = await GetRequest<CouponEntity[]>(database)

      if (response.success) {
        const temp = response.data?.map((item) => new CouponEntity(item)) ?? []

        couponMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetCoupon,
  }
}
